// Vendor libraries
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigModule } from 'Angular/config/config.module';
// Module imports
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class BackgroundJobsProgressPopoverModule {
}
BackgroundJobsProgressPopoverModule.ɵfac = function BackgroundJobsProgressPopoverModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BackgroundJobsProgressPopoverModule)(); };
BackgroundJobsProgressPopoverModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: BackgroundJobsProgressPopoverModule });
BackgroundJobsProgressPopoverModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule, CommonModule, ConfigModule, IconModule, TooltipModule] });
